<template>
  <div class="approval-opinion" v-if="opinionList.length">
    <div
      class="approval-opinion_item"
      v-for="(item, i) in opinionList"
      :key="i"
    >
      <div class="name">{{ item.name }}：</div>
      <div class="val">{{ item.dealMsg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      opinionList: [],
    };
  },
  watch: {
    list: {
      immediate: true,
      handler: function (e) {
        const arr = [];
        if (e.length) {
          e.forEach((item) => {
            if (
              item.approveResult == "agree" ||
              item.approveResult == "refuse"
            ) {
              arr.push({
                name: `${item.userName}${
                  item.approveResult == "agree" ? "(同意)" : "(拒绝)"
                }`,
                dealMsg: item.dealMsg
                  ? item.dealMsg
                  : `${item.approveResult == "agree" ? "同意" : "拒绝"}`,
              });
            }
          });
        }
        this.opinionList = arr;
      },
    },
  },
  methods: {},

  created() {},
};
</script>
<style lang="less" scoped>
.approval-opinion {
  min-height: 34px;
  background: #f2f4f9;
  border-radius: 4px;
  margin-top: 8px;
  &_item {
    height: 34px;
    display: flex;
    align-items: center;
    margin-top: -10px;
    &:nth-of-type(1) {
      margin-top: 0;
    }
    .name {
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #999999;
      padding-left: 8px;
    }
    .val {
      font-size: 13px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
    }
  }
}
</style>
